import styled from 'styled-components';

export const FooterArea = styled.footer`
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  text-align: center;
  color: #999;
  font-size: 14px;
  border-top: 1px solid #ccc;
  margin-top: 20px;

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
    };

    i {
      color: #E4405F;
      font-size: 1.5em;
    };
  };
`;